import cs from 'classnames';
import type { ComponentProps, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';

import styles from './link.module.css';

type P = {
  effects?: { focus?: boolean; hover?: boolean; radius?: boolean };
  icon?: ReactNode;
} & ComponentProps<typeof RouterLink>;

const defaultVariables = {};

const Link = ({
  children,
  className,
  effects: { focus = true, hover = true, radius = true } = defaultVariables,
  icon,
  ...rest
}: P) => {
  const { t } = useTranslation();

  return (
    <RouterLink
      className={cs(className, styles.link, {
        [styles['link-focus'] ?? '']: focus,
        [styles['link-hover'] ?? '']: hover,
        [styles['link-radius'] ?? '']: radius,
      })}
      {...rest}
    >
      {icon ? <span className={styles.icon}>{icon}</span> : undefined}
      {typeof children === 'string' ? t(children) : children}
    </RouterLink>
  );
};

export default Link;
